import React from 'react';
import styles from './Quote.module.scss';
import { Button, Text } from 'components/core';
import { Inline } from 'components/layout';

type QuoteProps = {
  quote: string;
  index: number;
  selected: boolean;
  onClick: (quote: string, index: number) => void;
};

const Quote = ({ quote, index, selected, onClick }: QuoteProps) => {
  return (
    <button
      type="button"
      className={styles.quoteButton}
      onClick={() => onClick(quote, index)}
      aria-label={`Show quote ${index + 1} in PDF`}
      aria-pressed={selected}
    >
      <Inline
        alignX="spaceBetween"
        alignY="top"
        className={styles.quoteContainer}
        component="span"
        spacing={2}
      >
        <Text className={styles.quote} size="sm" component="span">
          <span>&#8220;{quote}&#8221;</span>
        </Text>
        <Button
          type="neutral"
          variant="solid"
          component="span"
          size="xs"
          className={styles.viewInPdfButton}
        >
          View in PDF
        </Button>
      </Inline>
    </button>
  );
};

export default Quote;
